import Option from './option'

export default {
  desc: '培训结果',
  mixins: [Option],
  data() {
    return {
      list: [
        {
          id: '1',
          name: '未合格'
        },
        {
          id: '2',
          name: '已合格'
        }
      ]
    }
  }
}
